<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <table class="login-layout" v-if="isUIReady"><!-- //NOSONAR -->
    <tr>
      <td class="login-right">
        <div class="login-content">
          
          <div class="login-header">
            <div>
              <div class="login-app-logo" />
            </div>
          </div>
          <div class="login-body">
            <div v-if="isValidUuid" class="title">{{ $t('login.resetPassword.title') }}</div>
            <div v-if="isValidUuid">
              <el-form class="form" ref="form" :model="form" :rules="formRules">
                <div>
                  <div class="password-title">{{ $t('login.resetPassword.newPassword') }}</div>
                  <el-form-item  prop="newPassword">
                    <el-input ref="newPassword" v-model="form.newPassword" :type="newPasswordType" :placeholder="$t('account.newPassword.placeholder')" size="medium"></el-input>
                    <el-button :class="{'login-eye': true, 'login-eye-on': (newPasswordType=='text')}" @click="toggleNewPasswordVisibility"></el-button>
                  </el-form-item>
                  <div class="password-title">{{ $t('login.resetPassword.confirmPassword') }}</div>
                  <el-form-item prop="newPasswordConfirm">
                    <el-input :type="confirmPasswordType" ref="confirmPassword" v-model="form.newPasswordConfirm" :placeholder="$t('account.newPasswordConfirm.placeholder')" size="medium"></el-input>
                    <el-button :class="{'login-eye': true, 'login-eye-on': (confirmPasswordType=='text')}" @click="toggleConfirmPasswordVisibility"></el-button>
                  </el-form-item>
                </div>
              </el-form>
              <div class="form-buttons">
                <el-button class="wy-blue-button" @click="handleUpdate" :loading="isLoading">{{ $t('button.confirm') }}</el-button>
                <el-button class="wy-grey-button" @click="handleCancel" :disabled="isLoading">{{ $t('button.cancel') }}</el-button>
              </div>
              <div class="login-password-hints">
                <div class="title">{{ $t('account.hints.passwordFormatTitle') }}</div>
                <div class="desc" v-html="$t('account.hints.passwordFormatDesc')"></div>              
              </div>
            </div>  
            <div v-if="!isValidUuid" class="login-error" v-html="$t('login.resetPassword.invalidTokenError')" />
            <div v-if="!isValidUuid" class="login-error-relogin">
              <el-button class="wy-blue-button" @click="redirLogin" :loading="isLoading">{{ $t('button.returnToLoginPage') }}</el-button>
            </div>
          </div>
        </div>
      </td>
    </tr>
    <!-- <tr>
      <td :class="`login-left`"><br></td>
      <td class="login-right">
        <div class="login-content">
          <div class="title">{{ $t('login.resetPassword.title') }}</div>
          <div v-if="isValidUuid">
            <el-form class="form" ref="form" :model="form" :rules="formRules">
              <div>
                <div class="password-title">{{ $t('login.resetPassword.newPassword') }}</div>
                <el-form-item  prop="newPassword">
                  <el-input type="password" v-model="form.newPassword" :placeholder="$t('account.newPassword.placeholder')" size="medium"></el-input>
                </el-form-item>
                <div class="password-title">{{ $t('login.resetPassword.confirmPassword') }}</div>
                <el-form-item prop="newPasswordConfirm">
                  <el-input type="password" v-model="form.newPasswordConfirm" :placeholder="$t('account.newPasswordConfirm.placeholder')" size="medium"></el-input>
                </el-form-item>
              </div>
            </el-form>
            <div class="form-buttons">
              <el-button class="wy-blue-button" @click="handleUpdate" :loading="isLoading">{{ $t('button.confirm') }}</el-button>
              <el-button class="wy-grey-button" @click="handleCancel" :disabled="isLoading">{{ $t('button.cancel') }}</el-button>
            </div>
            <div class="login-password-hints">
              <div class="title">{{ $t('account.hints.passwordFormatTitle') }}</div>
              <div class="desc" v-html="$t('account.hints.passwordFormatDesc')"></div>              
            </div>
          </div>      
        </div>
        <div v-if="!isValidUuid" class="login-error" v-html="$t('login.resetPassword.invalidTokenError')" />
      </td>
    </tr> -->
  </table>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend ({
  name: 'reset-password',
  data() {
    return {
      params: null,
      isUIReady: false,

      newPasswordType: 'password',
      confirmPasswordType: 'password',
      form: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: ''
      },
      formRules: {
        newPassword: [
          { validator: (rule, value, callback) => {
            this.$root.passwordValidator(value, callback)
          }, required: true, trigger: ['blur', 'change']}
        ],
        newPasswordConfirm: [
          { validator: (rule, value, callback) => {
            this.$root.passwordConfirm(this.form.newPassword, value, callback)    
          }, required: true, trigger: ['blur', 'change']}
        ]
      },
      isValidUuid: false,
      isLoading: false
    }
  },
  methods: {
    ...mapActions(['authRequestPasswordValidate', 'authResetPassword']),

    toggleNewPasswordVisibility() {
      this.newPasswordType = (this.newPasswordType == 'password') ? 'text' : 'password';
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordType = (this.confirmPasswordType == 'password') ? 'text' : 'password';
    },
    redirLogin() {
      location.href = location.href.substr(0, location.href.indexOf('/#'));
    },    
    handleCancel() {
      this.$router.push({name: 'login'});
    },
    handleUpdate() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          if(this.form.confirmPassword != ''){
            let data = {
              newPassword: this.form.newPassword,
              confirmPassword: this.form.newPasswordConfirm,
              resetPwdEmailUUID: this.params.uuid,
              email: this.params.userEmail
            };

            this.isLoading = true;
            let res = await this.authResetPassword(data)
            if(res.status == 200){
              this.$router.push({path: '/'})
              this.$root.showNotificationLocale("success", "login.resetPassword.resetPasswordSuccessTitle", "login.resetPassword.resetPasswordSuccessMsg");
            }
            else if(res.data && res.data.errorCode) {
              this.$root.showNotificationLocale("error", null, `errorCode.code${res.data.errorCode}`);
            }
            else {
              this.$root.showNotificationLocale("error", 'error.serverErrorTitle', 'error.serverErrorMsg');
            }
            this.isLoading = false;
          }
        }
      });      
    }
  },
  async created() {
    this.params = this.$route.query;

    if(this.params && this.params.userEmail && this.params.uuid) {
      let res = await this.authRequestPasswordValidate({email: this.params.userEmail, uuid: this.params.uuid})
      if(res.status === 200){
        this.isValidUuid = true;
      }else{
        this.isValidUuid = false;
      }
    }
    else {
      this.isValidUuid = false;
    }
    this.isUIReady = true;
  }, 

  async mounted() {
    
  }
})
</script>

<style lang="scss">
.wy-resetPassword-page {
  overflow-y: auto;
  background-color: #0C2837;
  background-image: url('../assets/images/login_bg_owl.svg') !important;
  background-size: 48% 205%;
  background-repeat: no-repeat;
  background-position-x: 109%;
  background-position-y: 38.17%;
  .login-content {
    margin-top: 55px !important;
    > .title {
      font-size: 34px;
      font-family: sans-serif;
      vertical-align: middle;
      color: #214586;
      background-image: url('../assets/icons/alert_lock.svg');
      background-repeat: no-repeat;
      background-size: 50px 50px;
      background-position: 0px 0px;
      height: 55px;
      padding-left: 70px;
      padding-top: 7px;
    }
    .title {
      font-size: 16px;
      // color: #214586;
      font-weight: 400;
    }
    .form {
      margin-top: 45px;
      .password-title {
        font-size: 14px;
        color: #214586;
        font-weight: 700;
        padding-top: 0px;    
        text-align: left;
      }
      .login-eye {
        background-image: url("../assets/images/login_eye.svg");
        background-position-x: 0px;
        background-position-y: 3px;
        background-repeat: no-repeat;
        padding: 10px 10px 10px 10px;
        margin: 0px;
        background-color: transparent;
        border: 0;
        position: relative;
        left: 263px;
        top: -44px;
      }
      .login-eye.login-eye-on {
        background-image: url("../assets/images/login_eye_on.svg");
      }
      .el-form-item {
        margin-bottom: 0px;
        margin-top: 8px;
        input.el-input__inner {
          border-width: 1px !important;
          height: 50px;
          border-radius: 5px;
        }
        .el-form-item__content {
          line-height: 25px;
        }
        .el-form-item__error {
          // position: relative;
          top: 52px;
        }
      }
    }
    .form-buttons {
      padding-top: 10px;
      .wy-blue-button{
        width: 100%;
        display: block;
        padding: 18px 30px 18px 30px;
      }
      .wy-grey-button{
        width: 100%;
        margin-left: 0px;
        margin-top: 10px;
        padding: 18px 30px 18px 30px;
        background: unset;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        border: 1px solid #ddd;
      }
    }
  }
  .login-content {
    padding: 40px;
    width: 380.48px !important;
    height: 423px;
    left: calc(50% - 229px);
    position: inherit;
  }

  .login-body {
    -webkit-box-shadow: -6px 0px 20px #1d1541;
    box-shadow: -6px 0px 20px #1d1541;
    border-radius: 5px;
    background: #FFFFFF;
    padding: 40px 40px;
    margin-top: 45px;
    width: 298px;
    max-height: 508px;
    height: fit-content;
    
    .mfa-title {
      color: #214586;
      font-size: 26px;
      margin-bottom: 5px;
    }
    .mfa-desc {
      margin-bottom: 5px;
    }
    .mfa-input {
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .mfa-button {
      text-align: right;
    }

    .login-password-hints {
      margin-top: 34px !important;
      background-image: url('../assets/icons/alert_lock.svg');
      background-repeat: no-repeat;
      background-size: 31px 31px;
      background-position: 0px 0px;
      height: 85px;
      padding-left: 52px;
      padding-top: 1px;

      .title {
        font-size: 14px !important;
        font-weight: 700 !important;
      }
      .desc {
        font-size: 14px !important;
      }
    }
  }

  .login-app-logo {
    width: 330px !important;
    height: 110px !important;
    background-image: var(--header-logo);
    background-size: 330px 77px;
    background-repeat: no-repeat;
  }
  .login-error {
    margin-bottom: 25px;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    .wy-link-click {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .login-error-relogin .wy-blue-button {
    width: 100%;
    margin-top: 20px;
    padding: 18px 30px 18px 30px;
  }
}
</style>